import React from 'react';
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';

export function AllInboxIcon() {
  return <AllInboxRoundedIcon fontSize="small" />;
}
